import {inject, injectable} from "inversify";
import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {Notifier} from "@/modules/notifications/services/Notifier";
import AfterCurrencyExchangeEvent from "@/modules/action-points/ events/AfterCurrencyExchangeEvent";
import AfterBuyCoinsEvent from "@/modules/action-points/ events/AfterBuyCoinsEvent";
import {CoinsPurchasedNotification, CurrencyExchangeNotification} from "@/modules/action-points/entity";
import {GateTypeEnum} from "@/modules/action-points/enums";

@injectable()
export default class NotificationEventSubscriber implements EventSubscriber {
  constructor(
    @inject(Notifier) private notifier: Notifier,
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: AfterCurrencyExchangeEvent, callback: this.onAfterCurrencyExchangeEvent},
      {event: AfterBuyCoinsEvent, callback: this.onAfterBuyCoinsEvent},
    ];
  }

  public async onAfterCurrencyExchangeEvent(event: AfterCurrencyExchangeEvent) {
    if (event.type === GateTypeEnum.COINS) {
      return;
    }

    const notification = new CurrencyExchangeNotification().setPayload(event.type, event.coins, event.value);

    await this.notifier.notify(notification);
  }

  public async onAfterBuyCoinsEvent(event: AfterBuyCoinsEvent) {
    const notification = new CoinsPurchasedNotification().setPayload(event.product.coins);

    await this.notifier.notify(notification);
  }
}
